/*SYSTEM IMPORTS*/
import React from 'react'
import c from 'classnames'

import Img from 'components/Img'

import IconsImage from 'images/icons.svg'

import './style'
import './media'


const City = props => (
    <div className={c("city", props.className)}>
        <Img src={IconsImage} div/>
        {props.value.map( item => (<div key={item.id} className="doctor-city__item">
            {item.title}
        </div> ))}
    </div>
)

const Address = props => (
    <div className={c("city", props.className)}>
        <Img src={IconsImage} div/>
        <div className="doctor-city__item">
            {props.value}
        </div>
    </div>
)

export { City, Address }
